import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DriverService } from '../driver/services/driver.service';
import { PaymentSucessComponent } from '../booking-flow/payment-success/payment-success.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { MSG_BOOKING_CONFIRMATION, MSG_CUSTOM_INVOICE_CONFIRMATION, PAY_REPAY_SCHEDULE_SUCCESS_MSG, USER_CONVERTED_TO_GROUP_OPERATOR_SUCCESS_MSG, USER_ROLES } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-reattempt-booking-modal',
  templateUrl: './reattempt-booking-modal.component.html',
  styleUrls: ['./reattempt-booking-modal.component.scss'],
})
export class ReattemptBookingModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  bodyText: string = '';
  headerText: string = '';
  prefereedPaymentMethodId: string = '';
  bookingType: boolean = false;
  invoiceId: string = '';
  bookingId: string = '';
  scheduleDateTimeValue: string = '';
  isPreferredPaymentSelected: boolean = true;
  isFunctionAttempted: number = 0;
  roleName: string = '';
  userRoles = USER_ROLES;

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    public readonly driverService: DriverService,
    private readonly dialogControlService: DialogControlService,  
    private readonly toastService: ToastService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit(): void {
    this.bodyText = this.config.data?.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.isPreferredPaymentSelected = this.config?.data?.isPreferredPaymentSelected;
    this.scheduleDateTimeValue = this.config?.data?.scheduleDateTimeValue;
    this.bookingId = this.config?.data?.bookingId;
    this.invoiceId = this.config?.data?.invoiceId;
    this.bookingType = this.config?.data?.bookingType;
    this.prefereedPaymentMethodId = this.config?.data?.prefereedPaymentMethodId;
    this.isFunctionAttempted = this.config?.data?.isFunctionAttempted || 0;
    this.roleName = this.encryptStorage.getItem('roleName') || '';

  }

  yesButtonFun(): void {
    switch (this.isFunctionAttempted) {
      case 2:
        this.CreatePaymentByDefaultPaymentMethod();
        break;

      case 1:
        this.updateRoleToGroupOperator();    
        break;

      default:
        this.ref.close({ action: 'reattempt' });
        break;
    }
  }

  noButtonFun() {
    this.ref.close();
  }

  CreatePaymentByDefaultPaymentMethod() {
    let data = {
      paymentMethodId: this.prefereedPaymentMethodId,
      customInvoiceId: !this.bookingType ? this.invoiceId : null,
      bookingId: this.bookingType ? this.bookingId : null,
      IsPaymentDoInstantly: true,
      scheduledDate: this.scheduleDateTimeValue
    }
    this.driverService.CreatePaymentByDefaultPaymentMethod(data)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (response: any) => {
        this.close();
          if (response?.data?.nextActionType === 'redirect_to_url') {
            const url = response?.data?.nextActionUrl;
            if (url) {
              window.location.href = url;
            }
          } else {
            this.dialogControlService.openDialog(PaymentSucessComponent, {
              width: '30%',
              data: {
                assistedUrl: null,
                bodyText: this.setSuccessModalBodyMessage(),
                buttonText: 'OK',
                heading: this.isPreferredPaymentSelected ? 'Success' : 'Payment Initiated',
                isrefresh: true
              },
            });
      }
      }, error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
        
      }
    })
  }

  close() {
    this.ref.close();
  }

  setSuccessModalBodyMessage(): string {
    if (this.invoiceId) return MSG_CUSTOM_INVOICE_CONFIRMATION;
    if (this.isPreferredPaymentSelected && this.scheduleDateTimeValue != '') return PAY_REPAY_SCHEDULE_SUCCESS_MSG;
    if(this.isFunctionAttempted === 1) return USER_CONVERTED_TO_GROUP_OPERATOR_SUCCESS_MSG;
    return MSG_BOOKING_CONFIRMATION;
  }

  setRedirectionUrl(): string { 
    if (this.roleName === this.userRoles.PARKING_MANAGER || this.roleName === this.userRoles.PARKING_OWNER) {
      return 'manager/group-operator-info';
    } else if (this.roleName === this.userRoles.SUPER_ADMIN) {
      return 'super-admin/group-operator-info';
    }
    return '';
  }

  updateRoleToGroupOperator() {
    let request = {
      userId: this.config.data?.userId,
      companyName: this.config.data?.groupName,
      email: null,
    }

    this.driverService.updateRoleToGroupOperator(request)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (_response) => {
       
        this.close();
         
              this.dialogControlService.openDialog(PaymentSucessComponent, {
          width: '30%',
          data: {
            assistedUrl: this.setRedirectionUrl(),
            bodyText: this.setSuccessModalBodyMessage(),
            buttonText: 'OK',
            heading: 'Success',
            isrefresh: false,
            userId: this.config.data?.userId
          },
        });
        this.ref.close({ action: 'updateRole' });
      },
      error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
      }
    });
  }
}
